import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";
import { prependToInfiniteDataList } from "../../../utils";
import { extractRequestFromQueryKey } from "../../../keys";
import { modelMatchesGetSomeRequest } from "../filter-utils";

export const ENDUSER_ELIGIBILITY_RESULTS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"enduser_eligibility_results"> =
  {
    develop_health_run_benefit_verification: (_request, response) => ({
      getOne: {
        exact: false,
        predicate: ({ state: { data } }) => {
          return !!data && data.id === response?.result.id;
        },
        updater: response
          ? (oldData) => {
              if (oldData?.id === response.result.id) {
                return response.result;
              }
              return oldData;
            }
          : undefined,
      },
      getSome: {
        exact: false,
        predicate: ({ queryKey }) => {
          const queryRequest = extractRequestFromQueryKey(queryKey);
          if (!response?.result) {
            return false;
          }
          const matchesFilter = modelMatchesGetSomeRequest(response.result, queryRequest);
          return matchesFilter;
        },
        updater: response?.result
          ? (oldData) =>
              prependToInfiniteDataList({
                infiniteData: oldData ?? { pages: [], pageParams: [] },
                item: response.result,
              })
          : undefined,
      },
      getByIds: {
        exact: false,
        predicate: ({ queryKey }) => {
          if (!response) {
            return false;
          }
          const queryRequest = extractRequestFromQueryKey(queryKey);
          return !!queryRequest?.ids?.includes(response.result.id);
        },
      },
    }),
  };
